exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/_shared/nav-bar/nav-bar.component.css
// module id = ../../../../../src/app/_shared/nav-bar/nav-bar.component.css
// module chunks = main